/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Event Speed Icon component.
 */
export const EventSpeedIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <line x1='9.94971' y1='13.4805' x2='15.5962' y2='13.4805' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' />
      <line x1='9.94971' y1='25.9414' x2='15.5962' y2='25.9414' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' />
      <line x1='7.75' y1='19.7109' x2='14.3494' y2='19.7109' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' />
      <path d='M20.5351 8.03224C28.302 7.51445 33.5391 13.3314 33.5391 19.9414C33.5391 26.5514 28.302 32.3685 20.5351 31.8507' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <path d='M33.313 19.9424L30.8826 19.9424' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
      <path d='M27.043 14.0438L22.6224 18.5928' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
      <path d='M20.8267 8.00017L20.8267 10.4305' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
      <path d='M20.8267 29.3688L20.8267 31.8828' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
      <path d='M27.1108 26.8553L28.835 28.5703' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
      <path d='M20.4999 19.7975C20.4999 19.0428 21.1117 18.431 21.8664 18.431C22.6211 18.431 23.2329 19.0428 23.2329 19.7975C23.2329 20.5523 22.6211 21.1641 21.8664 21.1641C21.1117 21.1641 20.4999 20.5523 20.4999 19.7975Z' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
    </svg>
  );
};

export default EventSpeedIcon;
